export var Login = /*#__PURE__*/ function(Login) {
    Login["LOGIN"] = "LOGIN";
    Login["LOGIN_STARTED"] = "LOGIN_STARTED";
    Login["LOGOUT"] = "AUTH_LOGOUT";
    Login["TIMEOUT"] = "AUTH_TIMEOUT";
    Login["FAILED"] = "AUTH_FAILED";
    Login["SUCCESS"] = "AUTH_SUCCESS";
    Login["INITIAL"] = "AUTH_INITIAL";
    Login["IN_PROGRESS"] = "AUTH_IN_PROGRESS";
    Login["FORCE_PASSWORD_CHANGE"] = "FORCE_PASSWORD_CHANGE";
    Login["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
    Login["CHANGE_PASSWORD_INITIAL"] = "CHANGE_PASSWORD_INITIAL";
    Login["CHANGE_PASSWORD_SUCCESS"] = "CHANGE_PASSWORD_SUCCESS";
    Login["CHANGE_PASSWORD_FAILED"] = "_CHANGE_PASSWORD_FAILED";
    Login["AUTHENTICATE"] = "AUTHENTICATE";
    Login["COGNITO_AUTH"] = "COGNITO_AUTH";
    Login["JSPRING_AUTH"] = "JSPRING_AUTH";
    Login["CONFIRM_EMAIL"] = "CONFIRM_EMAIL";
    Login["POST_AUTH_NAVIGATE"] = "POST_AUTH_NAVIGATE";
    Login["GET_CONFIG"] = "GET_CONFIG";
    Login["SSO_LOGIN"] = "SSO_LOGIN";
    Login["EXCHANGE_TOKEN_SSO"] = "EXCHANGE_TOKEN_SSO";
    return Login;
}({});
export var CodeLookup = /*#__PURE__*/ function(CodeLookup) {
    CodeLookup["LOOKUP_CODES"] = "LOOKUP_CODES";
    return CodeLookup;
}({});
export var ForgotPassword = /*#__PURE__*/ function(ForgotPassword) {
    ForgotPassword["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
    ForgotPassword["SAVE_PASSWORD_DTO"] = "SAVE_PASSWORD_DTO";
    ForgotPassword["SUBMIT_NEW_PASSWORD"] = "SUBMIT_NEW_PASSWORD";
    ForgotPassword["INIT"] = "INIT";
    ForgotPassword["SUBMIT_FORGOT_PASSWORD"] = "SUBMIT_FORGOT_PASSWORD";
    ForgotPassword["_SUBMIT_NEW_PASSWORD"] = "_SUBMIT_NEW_PASSWORD";
    return ForgotPassword;
}({});
export var CaseDocuments = /*#__PURE__*/ function(CaseDocuments) {
    CaseDocuments["LOAD"] = "CASE_DOCUMENTS_LOAD";
    CaseDocuments["CASE_DETAIL"] = "CASE_DETAIL";
    CaseDocuments["FETCH_DOCUMENT"] = "FETCH_DOCUMENT";
    CaseDocuments["FETCH_CASERUN_DOCUMENTS"] = "FETCH_CASERUN_DOCUMENTS";
    CaseDocuments["DOCUMENT_METADATA"] = "DOCUMENT_METADATA";
    CaseDocuments["NOTE"] = "DOC_SERVICE_NOTE";
    return CaseDocuments;
}({});
export var Auth = /*#__PURE__*/ function(Auth) {
    Auth["TOKEN_AVAILABLE"] = "TOKEN_AVAILABLE";
    Auth["TOGGLE_SSO_USER"] = "TOGGLE_SSO_USER";
    Auth["SHOULD_REFRESH"] = "SHOULD_REFRESH";
    return Auth;
}({});
export var Analytics = /*#__PURE__*/ function(Analytics) {
    Analytics["INSTANTIATE_DASHBOARD"] = "INSTANTIATE_DASHBOARD";
    Analytics["SELECTED"] = "ANALYTICS_SELECTED";
    Analytics["GET_TABLEAU_TOKEN"] = "GET_TABLEAU_TOKEN";
    Analytics["SET_ACTIVE_DASHBOARD"] = "SET_ACTIVE_DASHBOARD";
    Analytics["SET_ACTIVE_DASHBOARD_RESOURCE"] = "SET_ACTIVE_DASHBOARD_RESOURCE";
    Analytics["GET_SUB_NAV_PATHS"] = "GET_SUB_NAV_PATHS";
    return Analytics;
}({});
export var UserContext = /*#__PURE__*/ function(UserContext) {
    UserContext["JUMP_CONTEXT"] = "JUMP_CONTEXT";
    UserContext["CHOOSE_CONTEXT"] = "CHOOSE_CONTEXT";
    UserContext["DISPLAY_CONTEXTS"] = "DISPLAY_CONTEXTS";
    UserContext["LIST"] = "LIST_CONTEXTS";
    UserContext["REFRESH_CONTEXT"] = "REFRESH_CONTEXT";
    UserContext["ONLY_REFRESH_CONTEXT"] = "ONLY_REFRESH_CONTEXT";
    return UserContext;
}({});
export var UserConfig = /*#__PURE__*/ function(UserConfig) {
    UserConfig["CONFIG_AVAILABLE"] = "CONFIG_AVAILABLE";
    return UserConfig;
}({});
export var ShortcutAction = /*#__PURE__*/ function(ShortcutAction) {
    ShortcutAction["NOT_FOUND"] = "NOT_FOUND";
    return ShortcutAction;
}({});
export var Organization = /*#__PURE__*/ function(Organization) {
    Organization["ASSOCIATION_CREATED"] = "ASSOCIATION_CREATED";
    Organization["NAVIGATE_ANCESTOR"] = "NAVIGATE_ANCESTOR";
    Organization["NAVIGATE"] = "ORG_NAVIGATE";
    Organization["ADD_CHILD"] = "ADD_CHILD";
    Organization["GET_ORGANIZATION"] = "GET_ORGANIZATION";
    Organization["LIST"] = "LIST_ORGANIZATIONS";
    Organization["AVAILABLE_ASSOCIATIONS"] = "AVAILABLE_ASSOCIATIONS";
    Organization["ORGANIZATION_SELECTED"] = "ORGANIZATION_SELECTED";
    Organization["SAVE"] = "ORGANIZATION_SAVE";
    Organization["IN_PROGRESS"] = "IN_PROGRESS";
    Organization["FORM_SUBMISSION"] = "FORM_SUBMISSION";
    Organization["FORM_SUBMISSION_ERROR"] = "FORM_SUBMISSION_ERROR";
    Organization["ORG_CHILDREN"] = "ORG_CHILDREN";
    Organization["RELATIONSHIP"] = "RELATIONSHIP";
    Organization["ORG_TO_ORG_RELATIONSHIP"] = "ORG_TO_ORG_RELATIONSHIP";
    Organization["TOGGLE_EDIT"] = "TOGGLE_EDIT";
    Organization["GET_TENANT_FILTER"] = "TENANT_FILTER";
    Organization["SERVICE_LINES"] = "SERVICE_LINES";
    Organization["STORE_ACTIVE"] = "STORE_ACTIVE";
    Organization["TIMEZONES"] = "TIMEZONES";
    Organization["GET_FEATURES"] = "GET_FEATURES";
    Organization["UPDATE_FEATURES"] = "UPDATE_FEATURES";
    Organization["REPLACE_ORGANIZATION_STATE"] = "REPLACE_ORGANIZATION_STATE";
    return Organization;
}({});
export var AssigningAuthorities = /*#__PURE__*/ function(AssigningAuthorities) {
    AssigningAuthorities["GET_HOSPITALS"] = "GET_HOSPITALS";
    AssigningAuthorities["LOAD_FORM"] = "LOAD_FORM";
    AssigningAuthorities["ADD"] = "ADD";
    AssigningAuthorities["EDIT"] = "EDIT";
    AssigningAuthorities["DELETE"] = "DELETE";
    return AssigningAuthorities;
}({});
export var User = /*#__PURE__*/ function(User) {
    User["LIST"] = "LIST_USERS";
    User["USER_SELECTED"] = "USER_SELECTED";
    User["ROLE_UPDATE"] = "ROLE_UPDATE";
    User["FORM_SUBMISSION"] = "FORM_SUBMISSION";
    User["FORM_SUBMISSION_ERROR"] = "USER_FORM_SUBMISSION_ERROR";
    User["AVAILABLE_ORGANIZATIONS"] = "AVAILABLE_ORGANIZATIONS";
    User["AVAILABLE_ROLES"] = "AVAILABLE_ROLES";
    User["ADD_USER_DETAILS"] = "ADD_USER_DETAILS";
    User["TOGGLE_PASSWORD_OPTIONS"] = "TOGGLE_PASSWORD_OPTIONS";
    User["TOGGLE_PASSWORD_CHANGE_MODAL"] = "TOGGLE_PASSWORD_CHANGE_MODAL";
    User["CHANGE_USERS_PASSWORD"] = "CHANGE_USERS_PASSWORD";
    User["TOGGLE_FILTER_ON"] = "TOGGLE_FILTER_ON";
    User["TOGGLE_SHOW_ERRORS"] = "TOGGLE_SHOW_ERRORS";
    return User;
}({});
export var AuditLog = /*#__PURE__*/ function(AuditLog) {
    AuditLog["LIST_AUDIT_LOG"] = "LIST_AUDIT_LOG";
    AuditLog["FILTER"] = "CASE_FILTER";
    AuditLog["DATE_FILTER"] = "DATE_FILTER";
    AuditLog["CLEAR_ALL_FILTERS"] = "CLEAR_ALL_FILTERS";
    AuditLog["SET_AUDIT_LOG_TYPE"] = "SET_AUDIT_LOG_TYPE";
    return AuditLog;
}({});
export var Metadata = /*#__PURE__*/ function(Metadata) {
    Metadata["SOURCES"] = "METADATA_SOURCES";
    Metadata["LIST_DEFINITIONS"] = "LIST_DEFINITIONS";
    Metadata["DEFINITION_SELECTED"] = "DEFINITION_SELECTED";
    Metadata["FETCH_DETAIL"] = "FETCH_DEFINTION_DETAIL";
    Metadata["SAVE_DEFINITION"] = "SAVE_DEFINITION";
    return Metadata;
}({});
export var Group = /*#__PURE__*/ function(Group) {
    Group["LIST"] = "LIST_GROUPS";
    Group["SELECTED"] = "GROUP_SELECTED";
    Group["NAVIGATE"] = "GROUP_NAVIGATE";
    Group["SAVE"] = "SAVE_GROUP";
    Group["DELETE"] = "DELETE_GROUP";
    Group["FETCH_DETAIL"] = "FETCH_GROUP_DETAIL";
    Group["CHOOSE_GROUP"] = "CHOOSE_GROUP";
    Group["LIST_GROUP_MEMBERS"] = "LIST_GROUP_MEMBERS";
    Group["ADD_GROUP_USER"] = "ADD_GROUP_USER";
    return Group;
}({});
export var Dictionary = /*#__PURE__*/ function(Dictionary) {
    Dictionary["TENANT_SELECTED"] = "TENANT_SELECTED";
    Dictionary["LIST"] = "LIST_DICTIONARY";
    Dictionary["SELECTED"] = "DICTIONARY_SELECTED";
    Dictionary["CHOOSE_ORG"] = "CHOOSE_ORG";
    Dictionary["CHOOSE_DICTIONARY"] = "CHOOSE_DICTIONARY";
    Dictionary["VALUE_SELECTED"] = "DICTIONARY_VALUE_SELECTED";
    Dictionary["FETCH_DETAIL"] = "FETCH_DICTIONARY_DETAIL";
    Dictionary["SAVE"] = "SAVE_DICTIONARY";
    Dictionary["NAVIGATE"] = "DICTIONARY_NAVIGATE";
    Dictionary["PUSH_PATH"] = "PUSH_PATH";
    Dictionary["SAVE_ASSOCIATED_DICTIONARIES"] = "SAVE_ASSOCIATED_DICTIONARIES";
    Dictionary["UPDATE_PUBLISHED_METADATA"] = "UPDATE_PUBLISHED_METADATA";
    return Dictionary;
}({});
export var DictionaryValues = /*#__PURE__*/ function(DictionaryValues) {
    DictionaryValues["LIST_VALUES"] = "LIST_DICTIONARY_VALUES";
    DictionaryValues["LOAD_VALUE_LIST"] = "VALUE_LIST";
    DictionaryValues["LOAD_VALUE"] = "LOAD_DICTIONARY_VALUE";
    DictionaryValues["TENANT"] = "TENANT_LIST_VALUES";
    DictionaryValues["SAVE_VALUE"] = "SAVE_VALUE_VALUES";
    DictionaryValues["CHOOSE_ROW"] = "CHOOSE_ROW_VALUES";
    DictionaryValues["LOAD_DICTIONARY"] = "LOAD_DICTIONARY_VALUES";
    DictionaryValues["PUBLISH_DICTIONARY"] = "PUBLISH_DICTIONARY_VALUES";
    DictionaryValues["DOWNLOAD_DICTIONARY"] = "DOWNLOAD_DICTIONARY_VALUES";
    DictionaryValues["DOWNLOAD_DICTIONARY_BY_REQUEST_ID"] = "DOWNLOAD_DICTIONARY_BY_REQUEST_ID";
    DictionaryValues["LIST_ASSOCIATED_DICTIONARIES"] = "LIST_ASSOCIATED_DICTIONARIES_VALUES";
    DictionaryValues["SET_STATUS_FILTER"] = "SET_STATUS_FILTER_VALUES";
    DictionaryValues["DELETE_DICTIONARY"] = "DELETE_DICTIONARY";
    DictionaryValues["TOGGLE_DELETE_MODAL"] = "TOGGLE_DELETE_MODAL";
    DictionaryValues["TOGGLE_INFO_MODAL"] = "TOGGLE_INFO_MODAL";
    DictionaryValues["TOGGLE_SECURITY_MODAL"] = "TOGGLE_SECURITY_MODAL";
    DictionaryValues["TOGGLE_PUBLISH_MODAL"] = "TOGGLE_PUBLISH_MODAL";
    DictionaryValues["UNRESTRICT_DICTIONARY"] = "UNRESTRICT_DICTIONARY";
    DictionaryValues["LIST_DICTIONARY_HISTORY"] = "LIST_DICTIONARY_HISTORY";
    DictionaryValues["UPDATE_DICTIONARY_DESCRIPTION"] = "UPDATE_DICTIONARY_DESCRIPTION";
    DictionaryValues["UPDATE_COLUMN_DEFS"] = "UPDATE_COLUMN_DEFS";
    DictionaryValues["LIST_COLUMN_VALUES"] = "LIST_COLUMN_VALUES";
    return DictionaryValues;
}({});
export var DictionaryUpload = /*#__PURE__*/ function(DictionaryUpload) {
    DictionaryUpload["UPLOAD_DICTIONARY"] = "UPLOAD_DICTIONARY";
    DictionaryUpload["UPLOAD_INIT"] = "UPLOAD_INIT";
    DictionaryUpload["LIST_DICTIONARIES"] = "LIST_DICTIONARIES";
    DictionaryUpload["LIST_COLUMNS"] = "LIST_COLUMNS";
    DictionaryUpload["CHOOSE_COL_REFERENCE"] = "CHOOSE_COL_REFERENCE";
    DictionaryUpload["ADD_COLUMN_METADATA"] = "ADD_COLUMN_METADATA";
    DictionaryUpload["REMOVE_COLUMN_METADATA"] = "REMOVE_COLUMN_METADATA";
    DictionaryUpload["TOGGLE_UPLOAD_TYPE"] = "TOGGLE_UPLOAD_TYPE";
    return DictionaryUpload;
}({});
export var AsyncDictionaryRequest = /*#__PURE__*/ function(AsyncDictionaryRequest) {
    AsyncDictionaryRequest["ASYNC_REQUEST_INIT"] = "ASYNC_REQUEST_INIT";
    AsyncDictionaryRequest["ASYNC_REQUEST_PROGRESS"] = "ASYNC_REQUEST_PROGRESS";
    AsyncDictionaryRequest["ASYNC_REQUEST_COMPLETE"] = "ASYNC_REQUEST_COMPLETE";
    AsyncDictionaryRequest["FETCH_REQUEST_STATUS"] = "FETCH_REQUEST_STATUS";
    AsyncDictionaryRequest["SELECT_DICTIONARY"] = "SELECT_DICTIONARY";
    return AsyncDictionaryRequest;
}({});
export var ColumnMetadataEditor = /*#__PURE__*/ function(ColumnMetadataEditor) {
    ColumnMetadataEditor["SELECT_KEY_COLUMN"] = "SELECT_KEY_COLUMN";
    ColumnMetadataEditor["CONFIRM_MAPPINGS_EXISTS"] = "CONFIM_MAPPINGS_EXISTS";
    ColumnMetadataEditor["SET_DICTIONARY_MAPPINGS"] = "SET_DICTIONARY_MAPPINGS";
    ColumnMetadataEditor["SAVE_COLUMN_METADATA"] = "SAVE_COLUMN_METADATA";
    ColumnMetadataEditor["INITIALIZE"] = "INITIALIZE_COL_METADATA_EDITOR";
    ColumnMetadataEditor["SELECT_ACTIVE_COLUMN"] = "SELECT_ACTIVE_COLUMN";
    ColumnMetadataEditor["SAVE_COLUMN_MAPPING"] = "SAVE_COLUMN_MAPPING";
    ColumnMetadataEditor["REMOVE_COLUMN_MAPPING"] = "REMOVE_COLUMN_MAPPING";
    return ColumnMetadataEditor;
}({});
export var ArchiveModal = /*#__PURE__*/ function(ArchiveModal) {
    ArchiveModal["TOGGLE_ARCHIVE_MODAL"] = "TOGGLE_ARCHIVE_MODAL";
    ArchiveModal["SELECT_ARCHIVE_ROW"] = "SELECT_ARCHIVE_ROW";
    ArchiveModal["ARCHIVE_CHILDREN"] = "ARCHIVE_CHILDREN";
    ArchiveModal["SAVE_POTENTIAL_ARCHIVES"] = "SAVE_POTENTIAL_ARCHIVES";
    ArchiveModal["ARCHIVE_ROW"] = "ARCHIVE_ROW";
    return ArchiveModal;
}({});
export var ServiceLine = /*#__PURE__*/ function(ServiceLine) {
    ServiceLine["CHOOSE_SERVICE_LINE"] = "CHOOSE_SERVICE_LINE";
    ServiceLine["SAVE_SERVICE_LINE"] = "SAVE_SERVICE_LINE";
    ServiceLine["NAVIGATE_SERVICE_LINE"] = "NAVIGATE_SERVICE_LINE";
    return ServiceLine;
}({});
export var UserPreferences = /*#__PURE__*/ function(UserPreferences) {
    UserPreferences["SAVE_PREFERENCE"] = "SAVE_PREFERENCE";
    UserPreferences["DELETE_PREFERENCE_VALUE"] = "DELETE_PREFERENCE_VALUE";
    UserPreferences["LOAD_USER_PREFERENCES"] = "LOAD_USER_PREFERENCES";
    UserPreferences["UPDATE_PREFERENCE_VALUE"] = "UPDATE_PREFERENCE_VALUE";
    return UserPreferences;
}({});
export var AccountSettings = /*#__PURE__*/ function(AccountSettings) {
    AccountSettings["TOGGLE_IS_OPEN"] = "TOGGLE_IS_OPEN";
    AccountSettings["SAVE_FORM_DATA"] = "SAVE_FORM_DATA";
    AccountSettings["SAVE_DEFAULTS"] = "SAVE_DEFAULTS";
    AccountSettings["UPDATE_FORM_DEFINITION"] = "UPDATE_FORM_DEFINITION";
    return AccountSettings;
}({});
export var NormalTime = /*#__PURE__*/ function(NormalTime) {
    NormalTime["SAVE_NORMAL_TIME"] = "SAVE_NORMAL_TIME";
    NormalTime["LIST_NORMAL_TIME"] = "LIST_NORMAL_TIME";
    return NormalTime;
}({});
export var MyStatus = /*#__PURE__*/ function(MyStatus) {
    MyStatus["TOGGLE_IS_OPEN_MY_STATUS"] = "TOGGLE_IS_OPEN_MY_STATUS";
    MyStatus["UPDATE_STATUS"] = "UPDATE_STATUS";
    MyStatus["LIST_STATUS"] = "LIST_STATUS";
    return MyStatus;
}({});
export var CapturedTime = /*#__PURE__*/ function(CapturedTime) {
    CapturedTime["TOGGLE_IS_OPEN_CAPTURED_TIME"] = "TOGGLE_IS_OPEN_CAPTURED_TIME";
    CapturedTime["LIST_CAPTURED_TIME_FOR_WEEK"] = "LIST_CAPTURED_TIME_FOR_WEEK";
    CapturedTime["LIST_PROTECTED_TIME_FOR_WEEK"] = "LIST_PROTECTED_TIME_FOR_WEEK";
    CapturedTime["DELETE_PROTECTED_TIME_ENTRY"] = "DELETE_PROTECTED_TIME_ENTRY";
    CapturedTime["UPDATE_PROTECTED_TIME_ENTRY"] = "UPDATE_PROTECTED_TIME_ENTRY";
    CapturedTime["ADD_PROTECTED_TIME_ENTRY"] = "ADD_PROTECTED_TIME_ENTRY";
    CapturedTime["GET_MAX_ALLOWED_BACKDATE"] = "GET_MAX_ALLOWED_BACKDATE";
    return CapturedTime;
}({});
export var ExternalApplications = /*#__PURE__*/ function(ExternalApplications) {
    ExternalApplications["LIST_EXTERNAL_APPS"] = "LIST_EXTERNAL_APPS";
    ExternalApplications["SELECT_EXTERNAL_APP"] = "SELECT_EXTERNAL_APP";
    ExternalApplications["LIST_EXTERNAL_APP_USERS"] = "LIST_EXTERNAL_APP_USERS";
    ExternalApplications["SELECT_EXTERNAL_APP_USER"] = "SELECT_EXTERNAL_APP_USER";
    ExternalApplications["SAVE_EXTERNAL_APP_USER"] = "SAVE_EXTERNAL_APP_USER";
    ExternalApplications["SELECT_ORG_EXTERNAL_APP"] = "SELECT_ORG_EXTERNAL_APP";
    ExternalApplications["SET_STATE_TO_DEFAULT"] = "SET_STATE_TO_DEFAULT";
    return ExternalApplications;
}({});
export var CaseConfig = /*#__PURE__*/ function(CaseConfig) {
    CaseConfig["LIST_CASE_CONFIGURATIONS"] = "LIST_CASE_CONFIGURATIONS";
    CaseConfig["SAVE_CASE_CONFIGURATION"] = "SAVE_CASE_CONFIGURATION";
    CaseConfig["SELECT_CASE_CONFIG_SECTION"] = "SELECT_CASE_CONFIG_SECTION";
    CaseConfig["REDUX_SAVE_CASE_CONFIGS"] = "REDUX_SAVE_CASE_CONFIGS";
    CaseConfig["LOAD_CASE_CONFIG_OPTIONS"] = "LOAD_CASE_CONFIG_OPTIONS";
    return CaseConfig;
}({});
export var Loading = /*#__PURE__*/ function(Loading) {
    Loading["LOADING_ACTION"] = "LOADING_ACTION";
    return Loading;
}({});
export var RulesList = /*#__PURE__*/ function(RulesList) {
    RulesList["LIST_RULES"] = "LIST_RULES";
    RulesList["GET_XML"] = "GET_XML";
    RulesList["CHOOSE_RULES_DIAGRAM"] = "CHOOSE_RULES_DIAGRAM";
    return RulesList;
}({});
export var CaseEdits = /*#__PURE__*/ function(CaseEdits) {
    CaseEdits["SET_ACTIVE_FIELD"] = "SET_ACTIVE_FIELD";
    CaseEdits["UPDATE_VALUE"] = "UPDATE_VALUE";
    CaseEdits["LOAD_PATIENT_DETAIL_OPTIONS"] = "LOAD_PATIENT_DETAIL_OPTIONS";
    CaseEdits["LOAD_ALL_PATIENT_DETAIL_OPTIONS"] = "LOAD_ALL_PATIENT_DETAIL_OPTIONS";
    CaseEdits["UPDATE_CASE"] = "UPDATE_CASE";
    CaseEdits["NAVIGATE_CODER_COMMENTS"] = "NAVIGATE_CODER_COMMENTS";
    return CaseEdits;
}({});
